import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadTemplateConfigPreparationRequest } from '../../actions/loadTemplateConfigPreparation';

import { getLoadTemplateConfigPreparationError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadTemplateConfigPreparationHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadTemplateConfigPreparationRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadTemplateConfigPreparationError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadTemplateConfigPreparationHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
